import { Network } from '@spritz-finance/sdk'
import { Dialog, Spacer } from '@spritz-finance/ui'
import { Row } from '../../../../../components/Layout/Row'
import { Wallet } from '../../../../../web3/Wallet'
import { AllowanceProvider } from '../allowance/AllowanceProvider'
import { useDirectPayContext } from '../context/DirectPayContext'

import { CreateDirectPaymentForm } from './CreateDirectPaymentForm'
import { ContentContainer } from '../../../../../components/ContentContainer'

export const CreateDirectPayment = () => {
    const { title, selectedToken } = useDirectPayContext()

    return (
        <AllowanceProvider
            token={
                selectedToken?.address
                    ? {
                          address: selectedToken!.address,
                          symbol: selectedToken!.symbol,
                          network: selectedToken!.network as Network,
                      }
                    : undefined
            }
        >
            <Dialog.Title>{title}</Dialog.Title>
            <Spacer height={16} />
            <Row align="center">
                <Wallet responsive clickable={false} />
            </Row>
            <ContentContainer>
                <CreateDirectPaymentForm />
            </ContentContainer>
        </AllowanceProvider>
    )
}
